import { Row, Col } from "react-bootstrap";

function Discord() {
    return <Row>
        <Col md={6} className="discord-col">
            <div className="discord-wrapper">
                <iframe className="discord-iframe"
                    src="https://discord.com/widget?id=955691009981960192&theme=dark"
                    width="350"
                    height="500"
                    allowtransparency="true"
                    frameborder="0"
                    sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                ></iframe>
            </div>
        </Col>
        <Col md={6}>
            <div className="discord-blurb">
                <p className="spacious-text">
                    By joining our Discord with over 100 members, you can stay up-to-date with all of our events, meetings, and announcements. You can also ask questions, get help with problems, and chat with other members of the club. We have channels for all sorts of topics, including math, competitions, and general discussion. We hope to see you there!
                </p>
            </div>
        </Col>
    </Row>
}

export default Discord;
